// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"f4886b2b","850":"fc8ebd9d"}[chunkId] + ".chunk.js";
};